import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('trigger-action', () => import(/* webpackMode: "lazy" */'./trigger-action'));
